module.exports = __webpack_public_path__ + "static/media/2.6a0f5448.jpg";